/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import Raven from 'raven-js';
import { useEffect, useState } from 'react';
import { getIsAdmin } from 'ui-addon-upgrades/_core/common/eligibility/getIsAdmin';
import { useMultiTrialTrackingProps } from 'ui-addon-upgrades/_core/trial/useMultiTrialTrackingProps';
import ErrorBoundary from '../../components/ErrorBoundary';
import { putJsonBlob } from '../../api/jsonBlobApi';
import { ContextualPromptConfig } from '../../constants/trials';
import ContextualTrialPrompt from '../../trial/prompts/ContextualTrialPrompt';
import { contextualPromptPromise } from '../../utils/contextualPromptPromise';
import { jsx as _jsx } from "react/jsx-runtime";
export const USER_SETTING_KEY = 'trials:contextual-prompts';
const getAppSettingsKey = (upgradeProduct, app) => `${upgradeProduct}-${app}`;

// Returns the upgrade product of the first active trial that gives access to the given `app`
// or undefined if no such trial.
const getActiveTrialUpgradeProduct = (app, activeTrials) => {
  if (!activeTrials) return undefined;
  const eligibleUpgradeProducts = Object.keys(ContextualPromptConfig);
  return eligibleUpgradeProducts.find(upgradeProduct => {
    var _ContextualPromptConf;
    const existsPromptForApp = (_ContextualPromptConf = ContextualPromptConfig[upgradeProduct]) === null || _ContextualPromptConf === void 0 ? void 0 : _ContextualPromptConf[app];
    return existsPromptForApp && activeTrials.includes(upgradeProduct);
  });
};
const ContextualTrialPromptContainer = ({
  app
}) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [upgradeProduct, setUpgradeProduct] = useState(undefined);
  const {
    activeTrials,
    expiredTrials,
    isMultiTrial,
    isLoadingTrackingProps
  } = useMultiTrialTrackingProps();
  useEffect(() => {
    if (isLoadingTrackingProps || !activeTrials || activeTrials.length === 0) {
      return;
    }
    Promise.all([getIsAdmin(), contextualPromptPromise()]).then(([isAdmin, contextualPromptsSetting]) => {
      const activeTrialUpgradeProduct = getActiveTrialUpgradeProduct(app, activeTrials);
      const isInTrial = !!activeTrialUpgradeProduct;
      const appSettingsKey = getAppSettingsKey(activeTrialUpgradeProduct, app);
      const hasPreviouslyViewedPrompt = !!contextualPromptsSetting[appSettingsKey];
      const shouldShowPrompt = !hasPreviouslyViewedPrompt && isAdmin && isInTrial;
      setUpgradeProduct(activeTrialUpgradeProduct);
      setShowPrompt(shouldShowPrompt);
      if (shouldShowPrompt) {
        putJsonBlob(USER_SETTING_KEY, Object.assign({}, contextualPromptsSetting, {
          [appSettingsKey]: true
        }));
      }
    }).catch(error => {
      Raven.captureException(new Error('Error setting up ContextualTrialPrompt data'), {
        extra: {
          error,
          app
        }
      });
    });
  }, [activeTrials, app, isLoadingTrackingProps]);
  if (!showPrompt || isLoadingTrackingProps || !upgradeProduct) return null;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    boundaryName: "TrialsContextualPrompt",
    children: /*#__PURE__*/_jsx(ContextualTrialPrompt, {
      app: app,
      activeTrials: activeTrials,
      expiredTrials: expiredTrials,
      isMultiTrial: isMultiTrial,
      upgradeProduct: upgradeProduct,
      setShowPrompt: setShowPrompt
    })
  });
};
export default ContextualTrialPromptContainer;